module.exports = __webpack_public_path__ + "src/assets/img/02_durchschlag.6951bc83.svg";